import { Button, Dialog, DialogActions, DialogContent, Divider, TextField } from "@mui/material"
import { useEffect, useState } from "react";
import { formatBirthDate, isValidBrDate } from "../../utils/birthdate";
import { formatPhone } from "../../utils/phone";
import { justNumbers } from "../../utils/justnumbers";
import { isValidCPF } from "../../utils/cpf";
import { formatCPF } from "../../utils/formatcpf";
import { LoadingButton } from "@mui/lab";
import { TableWithSearchAndSortEngine } from "../utils/table";
import { sendServerRequest } from "../../server/request";
import { openGlobalSnack } from "../utils/snack";
import { CircularLoading } from "../utils/loading";
import { serverRequestError } from "../utils/checkservererror";

export function CltElibility(){
   const [openDialog,setOpenDialog]=useState(false);
   const [loadingItems,setLoadingItems]=useState(true);
   const [items,setItems]=useState([]);
   useEffect(()=>{
      if(!loadingItems)return;
      sendServerRequest('GET','/server/clt/elegibility/list').then(e=>{

        setItems(e.data.data.list);
        setLoadingItems(false);
      }).catch(e=>{
          openGlobalSnack('Error ao carregar, atualize a sua pagina.','error');
      })
   })
   return (<div>
    <h1 style={{marginTop:10,marginBottom:30,fontSize:25}}>Consulta de Eligibilidade</h1>
    <Button variant="contained" onClick={()=>setOpenDialog(true)}>Criar Consulta</Button>
    <CreateConsult close={()=>setOpenDialog(false)} updateList={()=>setLoadingItems(true)} open={openDialog}/>
    <div style={{marginTop:'15px'}}>
    {loadingItems?<CircularLoading/>:<TableWithSearchAndSortEngine header={[
    {
        label:'Nome',
        id:'name',
    },
    {
      label:'CPF',
      id:'cpf'
    },

    {label:'Descrição',id:'description',allowSort:false},
    {
        label:'Status',
        id:'status'
    },]} items={items}/>}
    </div>
   </div>)
}

function CreateConsult({open,close,updateList}:{open:boolean,close:any,updateList:any}){
    const [loadingCreate,setLoadindCreate]=useState(false);
   // const [name,setName]=useState('');
    //const [motherName,setMotherName]=useState('');
    //const [birthDate,setBirthDate]=useState('');
    const [phone,setPhone]=useState('');
    const [cpf,setCpf]=useState('');
    useEffect(()=>{
       if(!loadingCreate)return;
       sendServerRequest('POST','/server/clt/consult/elegebility',{
        cpf,
        phone,
       }).then(e=>{
          openGlobalSnack('Consulta criada com sucesso.','success');
         setLoadindCreate(false);
         updateList();
         close();
         setCpf('');

         setPhone('');

       }).catch(e=>{
             serverRequestError(e);
         setLoadindCreate(false);
       });
    },[loadingCreate]);
    useEffect(()=>{
       if(!loadingCreate)return;
    },[loadingCreate]);
    return (<Dialog open={open}>
       <DialogContent>
            <div style={{textAlign:'center'}}>
            <Div field="Documento"/>
            <TextField disabled={loadingCreate} fullWidth error={Boolean(cpf)&&!isValidCPF(cpf)} value={cpf} onChange={(e)=>{
                 const val=justNumbers(e.target.value);
                 if(val.length==11){
                    setCpf(formatCPF(val));
                 }else{
                    setCpf(val);
                 }
            }} label='CPF'/>
               <Div field="Contato"/>     
         
            <TextField disabled={loadingCreate} error={Boolean(phone)&&justNumbers(phone).length!==11}  value={phone} sx={{marginBottom:"5px"}}  label='Telefone' onChange={(v)=>{setPhone(formatPhone(justNumbers(v.target.value).substring(0,11)))}}/>      
            </div>
            <LoadingButton onClick={()=>setLoadindCreate(true)} loading={loadingCreate} fullWidth variant="contained" disabled={!canCreate()}>Consultar Eligibilidade</LoadingButton>
       </DialogContent>
       <DialogActions>
        <Button  onClick={close} disabled={loadingCreate} variant="contained">Sair</Button>
       </DialogActions>
    </Dialog>)
    function canCreate(){

            if(justNumbers(phone).length!==11)return false;
            if(!isValidCPF(cpf))return false;
            return true;
    }
}

function Div({field}:{field:string}){
        return (<div>
            <p>{field}</p>
            <Divider sx={{marginTop:'4px',marginBottom:'4px'}}/>
        </div>)
}